import { reactErrorHandler } from '@sentry/react';
import type { RootOptions } from 'react-dom/client';

export const rootOptions: RootOptions = {
  onUncaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
};
